var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateİcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #7e8d9d;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.12,18.83l-2.02.83c-.78.17-1.38-.72-1.07-1.41.11-.26.32-.36.55-.48,1.2-.61,2.62-1.02,3.85-1.6.55-.14.98.02,1.24.52.64,1.26,1.06,2.78,1.68,4.06.2.9-.98,1.54-1.63.93-.33-.31-.6-1.31-.83-1.77-.02-.04-.03-.13-.1-.11-.22.48-.57.98-.91,1.39-4.54,5.61-13.28,4.87-16.86-1.34-.36-.62-1.08-2.12-1.04-2.8s.96-1.09,1.53-.68c.38.27.59,1.28.8,1.75,2.5,5.71,10.3,6.67,14.15,1.73l.64-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.8,11.11c.63-.15,1.27-.59,1.89-.76,1.16-.32,1.82,1.22.7,1.82-1.21.65-2.74,1.04-3.99,1.66-.45.11-.88-.12-1.09-.51-.66-1.18-1.05-2.78-1.68-4.01-.22-1.21,1.29-1.75,1.86-.59.23.46.37.97.6,1.43,1.22-2.08,3.08-3.63,5.34-4.5,4.97-1.9,10.87.59,12.99,5.45.32.74,1.04,2.23-.07,2.61-1.27.43-1.35-.98-1.7-1.8-.83-1.96-2.48-3.57-4.44-4.38-3.88-1.6-8.37-.06-10.41,3.59Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateİcon);
export default __webpack_public_path__ + "static/media/update_icon.95db11d1d8a07d5805a81c874653c3fc.svg";
export { ForwardRef as ReactComponent };